/* eslint-disable */

import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SelectPage from "./Pages/SelectPage";
import MainPage from "./Pages/MainPage";
import ResultPage from "./Pages/ResultPage";
import { ThemeContext } from "./context/ThemeContext";

function App() {
  const [selectMyState, setselectMyState] = useState("MBTI");
  const [selectYourState, setselectYourState] = useState("MBTI");

  return (
    <ThemeContext.Provider
      value={{
        selectMyState,
        setselectMyState,
        selectYourState,
        setselectYourState,
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/select" element={<SelectPage />} />
          <Route path="/result" element={<ResultPage />} />
        </Routes>
      </BrowserRouter>
    </ThemeContext.Provider>
  );
}

export default App;
